import React, { useEffect, useState } from 'react'
import publicApi from '../helper/publicApi'

const BottomFooter = () => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await publicApi.getSettings();
                if (response.success) {
                    setSettings(response.data);
                }
            } catch (error) {
                console.error('Error fetching footer settings:', error);
            }
        };
        fetchSettings();
    }, []);

    const copyright = settings?.footer_copyright || 'Wamad Marketing © 2026. All Rights Reserved';

    return (
        <div className="bottom-footer bg-color-one py-8">
            <div className="container container-lg">
                <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
                    <p className="bottom-footer__text ">
                        {copyright}
                    </p>
                    <div className="flex-align gap-8 flex-wrap">
                        <span className="text-heading text-sm">Nous Acceptons</span>
                        <img src="assets/images/thumbs/payment-method.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BottomFooter